import { ArrowRightOutlined } from '@ant-design/icons';
import { MessageDisplay } from 'components/common';
import { ProductShowcaseGrid } from 'components/product';
import { FEATURED_PRODUCTS, RECOMMENDED_PRODUCTS, SHOP } from 'constants/routes';
import {
  useDocumentTitle, useFeaturedProducts, useRecommendedProducts, useScrollTop
} from 'hooks';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import bannerImg from 'images/friends.jpg';
import banner2Img from 'images/heartbreak.jpg';
import { useSelector } from 'react-redux';
import { Modal } from '../../styles/5 - components/modal';
import { history } from '../../routers/AppRouter';
import { apiUrl } from '../../helpers/utils'


const Home = () => {
  const store = useSelector((state) => ({
    user: state.auth,
    isAuthenticating: state.app.isAuthenticating,
    isLoading: state.app.loading
  }));
  useDocumentTitle('My Breakup Registry | Home');
  useScrollTop();
  const [showSearchModal, setShowSearchModal] = useState(false);
  const [fetching, setFetching] = useState(false);
  const [searchResult, setSearchResult] = useState('');
  const [search, setSearch] = useState('');
  const [timeoutState, setTimeoutState] = useState(null);
  
  const httpRequestSearchUser = (email) => {
    fetch(`${apiUrl}/search-user?email=${email}`)
      .then((response) => {
        const json = response.json();
        if (response.ok) {
          return json;
        }
        return Promise.reject('Something went wrong.');
      })
      .then((json) => {
        if (json.user) history.push(`/user/${json.user}`);
        else alert('This user was not found.');
        setSearch('')
        setFetching(false);
      })
      .catch((e) => {
        console.log('e', e);
        setFetching(false);
      });
  };

  const onClickToggleSearchModal = () => {
    setShowSearchModal(!showSearchModal);
    setSearchResult([]);
    setSearch('');
  };

  const onChangeSearch = (event) => {
    setSearch(event.target.value);
  };

  const handleKeyDownSearch = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      onKeyUpSearch(event);
    }
  };

  const onKeyUpSearch = (event) => {
    if (search && search.length > 0) {
      clearTimeout(timeoutState);
      setTimeoutState(
        setTimeout(() => {
          httpRequestSearchUser(search);
          setFetching(true);
        }, 500)
      );
    }
  };

  return (
    <main className="content-front">
      <div className="home">
        <div className="intro-holder">
          <div className="visual-block">
            <section className="img-section">
              <div className="bg-stretch priority">
                <img className="left-img" src={banner2Img} />
              </div>
              <div className="title-holder">
                <button className="title-box">
                  <a href={store.user ? '/setup' : '/signin'}>
                    <h1 className="home-title">I’m breaking up!</h1>
                  </a>
                </button>
              </div>
            </section>
            <section className="img-section right-img">

              <div className="bg-stretch">
                <img src={bannerImg} />
              </div>
              <div className="title-holder">
                <button className="title-box" onClick={() => setShowSearchModal(true)}>
                  <h1 className="home-title">I want to help my newly single friend.</h1>
                </button>
              </div>

            </section>
          </div>
        </div>
        <Modal show={showSearchModal}>
          <div>
            <button type="button" className="modal-close-button" onClick={onClickToggleSearchModal}>&times;</button>
            <h1>Search for Your Friend by Email</h1>
            <input
              onSubmit={(e) => {
                e.preventDefault();
                httpRequestSearchUser();
              }}
              disabled={fetching}
              type="search"
              value={search}
              onChange={onChangeSearch}
              onKeyDown={handleKeyDownSearch}
                // onKeyUp={onKeyUpSearch}
              placeholder="Search for your friend"
            />
            <button className="importButton" type="button" onClick={onKeyUpSearch}>search</button>
            <section>
              {fetching && (
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="38"
                  height="38"
                  viewBox="0 0 38 38"
                  stroke="#666666"
                >
                  <g fill="none">
                    <g transform="translate(1 1)" strokeWidth="2">
                      <circle strokeOpacity=".5" cx="18" cy="18" r="18" />
                      <path
                        d="M36 18c0-9.94-8.06-18-18-18"
                        transform="rotate(277.527 18 18)"
                      >
                        <animateTransform
                          attributeName="transform"
                          type="rotate"
                          from="0 18 18"
                          to="360 18 18"
                          dur="1s"
                          repeatCount="indefinite"
                        />
                      </path>
                    </g>
                  </g>
                </svg>
              </div>
              )}
              {!fetching
              && searchResult
                && (
                  <a href={`http://my-break-up-registry-llc.web.app/user/${searchResult}`}>
                    <button>{search}</button>
                  </a>
                )}
            </section>
          </div>
        </Modal>
      </div>
    </main>
  );
};

export default Home;
